<template>

<input
	class="input"
	:type="type"
	:value="value"
	:placeholder="placeholder"
	:maxlength="maxlength || null"
	:disabled="disabled"
	:aria-label="ariaLabel || placeholder || null"
	:autocomplete="autocomplete || null"
	v-on:input="$emit('input', $event.target.value)"
	v-on:keydown="$emit('keydown', $event)"
	v-on:focus="$emit('focus', $event)"
	v-on:blur="$emit('blur', $event)"
/>

</template>

<script>

/*
	The boxart text field: light editorial, NOT tally's deep mono well.
	White ground, hairline (--tile) border, 8px radius, IBM Plex Sans, a soft
	accent focus ring. Keydown is forwarded so callers (the guess autocomplete)
	can drive arrow / enter navigation.
*/

export default {

	props: {
		value: {
			default: ''
		},
		placeholder: {
			default: ''
		},
		maxlength: {
			default: false
		},
		type: {
			default: 'text'
		},
		disabled: {
			type: Boolean,
			default: false
		},
		ariaLabel: {
			default: ''
		},
		autocomplete: {
			default: 'off'
		}
	}

}

</script>

<style scoped>

.input {
	display: block;
	width: 100%;
	box-sizing: border-box;
	height: 48px;
	padding: 0 14px;
	background: #fff;
	border: 1px solid var(--tile);
	border-radius: var(--radius);
	font-family: var(--font-body);
	font-size: 15px;
	color: var(--ink);
	outline: none;
	transition: border-color 140ms ease, box-shadow 140ms ease;
}

.input:focus {
	border-color: var(--accent);
	box-shadow: 0 0 0 3px rgba(63, 93, 138, 0.18);
}

.input:disabled {
	background: #faf7f0;
	color: var(--muted);
	cursor: default;
}

.input::placeholder {
	color: var(--muted);
}

</style>
